module.exports = __webpack_public_path__ + "media/images/icons/fb-color-ae78a6eee92e5f02f52a60702d7e4830.svg";